import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Point, Ticker} from 'pixi.js';
import {AppearingContainer} from "./AppearingContainer";

// Constructor
export class AnimatedSprite extends AppearingContainer {

  constructor(x, y, asset, appearingScreenPercent, game) {
    super(appearingScreenPercent, game);

    // top left position
    this.pos = {
      x: x,
      y: y
    }

    this.asset = asset;
    this.sprite = null;

    this.build();
  }

  build() {

    this.sprite = new PIXI.Sprite(this.asset);

    this.position.x = this.pos.x;
    this.position.y = this.pos.y;

    this.addChild(this.sprite);

    this.reset();
  }

  buildAnimations() {
    this.inAnimation = gsap.from(this,
      {
        pixi: {
          alpha: 0,
        },
        ease: "quad.out",
        immediateRender: true, // alpha 0 immediately, even if tween is paused
        paused: true,
        duration: 1,
      }
    )
  }

  getPositionOnScreen() {
    return this.sprite.toGlobal(new Point(0, 0));
  }
}
